module.exports = __webpack_public_path__ + "img/nav-startmeeting-on.0b5de064.png";